import type {
  PreviewDiffTablePair,
  PreviewDiffTocChunk,
} from "@/apis/compare/route";

/** table pair 에 셀/축/행 변경이 하나라도 있으면 변경으로 본다. */
export const pairHasChanges = (pair: PreviewDiffTablePair): boolean =>
  pair.changedCells.length > 0 ||
  pair.addedAxisColumns.length > 0 ||
  pair.removedAxisColumns.length > 0 ||
  pair.addedLineItemRows.length > 0 ||
  pair.removedLineItemRows.length > 0;

/** TOC 에 추가/삭제 테이블이 있거나 변경된 pair 가 있으면 변경으로 본다. */
export const tocHasChanges = (toc: PreviewDiffTocChunk): boolean =>
  toc.addedTables.length > 0 ||
  toc.removedTables.length > 0 ||
  toc.tablePairs.some(pairHasChanges);

/** 변경 사항 개수(변경 pair + 추가 테이블 + 삭제 테이블)의 합. */
export const countChangedItems = (tocs: PreviewDiffTocChunk[]): number =>
  tocs.reduce(
    (sum, toc) =>
      sum +
      toc.tablePairs.filter(pairHasChanges).length +
      toc.addedTables.length +
      toc.removedTables.length,
    0,
  );
